<section class="px-xs !py-lg h-full overflow-y-auto bg-white" hlmCard>
  <div class="px-md flex items-center justify-between">
    <h3 hlmCardTitle>Administration des sites</h3>
    <div hlmCardAction>
      <button (click)="ajouterSite()" hlmBtn variant="secondary">
        <ng-icon name="lucidePlus" />
        Ajouter un CFA
      </button>
    </div>
  </div>
  <div class="gap-xl grid" hlmCardContent>
    <div hlmTableContainer>
      <table hlmTable>
        <thead hlmTHead>
          <tr hlmTr>
            <th hlmTh>Région de France</th>
            <th hlmTh>CFA</th>
            <th hlmTh>Actions</th>
          </tr>
        </thead>
        <tbody hlmTBody>
          @for (site of sites() | trierPar: 'region'; track site.id) {
            <tr hlmTr>
              <td hlmTd>
                {{ site.region }}
              </td>
              <td hlmTd>
                {{ site.nom }}
              </td>
              <td hlmTd>
                <button
                  [hlmDropdownMenuTrigger]="menu"
                  [hlmDropdownMenuTriggerData]="{ $implicit: site }"
                  (click)="$event.stopPropagation()"
                  hlmBtn
                  variant="ghost"
                  size="icon"
                >
                  <ng-icon name="lucideEllipsisVertical" />
                </button>
              </td>
            </tr>
          } @empty {
            <tr hlmTr>
              <td hlmTd colspan="3">Aucun CFA</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>

  <ng-template #menu let-ctx>
    <hlm-dropdown-menu>
      <hlm-dropdown-menu-group>
        <button (triggered)="modifierSite(ctx)" hlmDropdownMenuItem>
          <ng-icon hlm name="lucidePen" size="sm" />
          Modifier le CFA
        </button>
        <button (triggered)="supprimerSite(ctx)" hlmDropdownMenuItem>
          <ng-icon hlm name="lucideTrash" size="sm" />
          Supprimer le CFA
        </button>
      </hlm-dropdown-menu-group>
    </hlm-dropdown-menu>
  </ng-template>
</section>
